import React from 'react';
import { ApolloProvider } from '@apollo/client';
import ReactDOM from 'react-dom/client';
import { register } from 'swiper/element/bundle';
import 'sanitize.css';

import { client } from './src/components/apolloClient';
import AuthProvider from './src/components/AuthProvider';
import { AppProvider } from './src/components/context';
import { CartProvider } from './src/components/Cart/CartContext';
import CartAuthSync from './src/components/Cart/CartAuthSync';
import CookieBanner, { ConsentScripts } from './src/components/CookieConsent';
import GlobalStyles from './src/static/styles/global.css';
import FontStyles from './src/theme/fonts';

export const onClientEntry = () => {
  register(); // Register swiper.js
};

export const wrapRootElement = ({ element }) => (
  <ApolloProvider client={client}>
    <AuthProvider>
      <AppProvider>
        <CartProvider>
          <CartAuthSync />
          {element}
          <ConsentScripts />
        </CartProvider>
      </AppProvider>
    </AuthProvider>
  </ApolloProvider>
);

export const wrapPageElement = ({ element }) => (
  <>
    <GlobalStyles />
    <FontStyles />
    {element}
    <CookieBanner />
  </>
);

export const replaceHydrateFunction = () => {
  return (element, container) => {
    const root = ReactDOM.createRoot(container);
    root.render(element);
  };
};
